jQuery(document).ready(function($) {
    'use strict';

    (function() {
        const geojson = {
            type: 'FeatureCollection',
            features: [
                {
                    type: 'Feature',
                    properties: {
                        is_promoted: window.hotel.is_promoted ? 1 : 0,
                    },
                    geometry: {
                        type: 'point',
                        coordinates: [
                            window.hotel.coordinates.lng,
                            window.hotel.coordinates.lat,
                        ],
                    },
                },
            ],
        };

        const map = new mapboxgl.Map({
            container: document.querySelector('#map'),
            style: 'mapbox://styles/mapbox/streets-v12',
            center: window.hotel.coordinates,
            zoom: 10,
            cooperativeGestures: true,
        });

        map.on('load', function() {
            map.addSource(
                'hotels',
                {
                    type: 'geojson',
                    data: geojson,
                    cluster: true,
                    clusterMaxZoom: 14,
                    clusterRadius: 50,
                },
            );

            const images = [
                {
                    id: 'hotel-marker',
                    url: '/wp-content/themes/svenskamoten.se/static/images/map-icon-2x.png',
                },
                {
                    id: 'hotel-marker-non-member',
                    url: '/wp-content/themes/svenskamoten.se/static/images/map-icon-non-member-2x.png',
                },
            ];

            Promise.all(
                images.map(function(image) {
                    return new Promise(function(resolve) {
                        map.loadImage(
                            image.url,
                            function(error, result) {
                                map.addImage(image.id, result);
                                resolve();
                            },
                        );
                    });
                }),
            ).then(function() {
                map.addLayer({
                    id: 'unclustered-hotels',
                    type: 'symbol',
                    source: 'hotels',
                    layout: {
                        'icon-anchor': 'bottom',
                        'icon-image': [
                            'match',
                            ['get', 'is_promoted'],
                            1, 'hotel-marker',
                            0, 'hotel-marker-non-member',
                            'hotel-marker-non-member',
                        ],
                        'icon-size': 0.25,
                        'icon-allow-overlap': true,
                    },
                });
            });
        });
    }());

    $(document.body).on('click', '.hotel-cta-trigger', function() {
        $(this).toggleClass('active');
        $('.hotel-cta-widget').toggleClass('active');
        $('html').toggleClass('hotel-booking-open');
    });

    $(document.body).on('click', '.hotel-cta-close', function() {
        $('.hotel-cta-trigger').removeClass('active');
        $('.hotel-cta-widget').removeClass('active');
        $('html').removeClass('hotel-booking-open');
    });

    var distance = $('.hotel-content').offset().top;

    $(window).scroll(function() {
        if ($(this).scrollTop() >= distance) {
            $('.hotel-menu').addClass('active');
        } else {
            $('.hotel-menu').removeClass('active');
        }
    });

    $(document.body).on('click', '.hotel-menu button', function() {
        const target = parseFloat($(this).attr('data-id'));
        const current_target = parseFloat($('.hotel-content').attr('data-id'));

        let offsetModifier = 52;
        if (current_target >= target) {
            offsetModifier = 148;
        }

        const $scrollTarget = $(`.scroll-target[data-id="${target}"]`);

        $('html, body').animate({
            scrollTop: $scrollTarget.offset().top - offsetModifier,
        });

        $('.hotel-content').attr('data-id', target);
    });
});

//# sourceMappingURL=hotel.js.map
